import { render, staticRenderFns } from "./ProspectsList.vue?vue&type=template&id=6444f244&scoped=true"
import script from "./ProspectsList.vue?vue&type=script&lang=js"
export * from "./ProspectsList.vue?vue&type=script&lang=js"
import style0 from "./ProspectsList.vue?vue&type=style&index=0&id=6444f244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6444f244",
  null
  
)

export default component.exports